import {Serializer} from '../interfaces/serializer';
import {DataSource} from '../interfaces/data-source';
import {BehaviorSubject} from 'rxjs';
import {DatasetDimensionsGroupComponentObject} from './dataset-dimensions-group-component-object';
import {DimensionComponentObjects} from './dimension-component-object';
import {DatasetMetricsGroupComponentObject} from './dataset-metrics-group-component-object';
import {MetricComponentObjects} from './metric-component-object';
import {DatasetUsageCustomConfigurationComponentObject} from "./dataset-usage-custom-configuration-component-object";
import {CustomImportComponentObject} from "./custom-import-component-object";

export type DatasetUsageComponentObjects = Array<DatasetUsageComponentObject>;

export class DatasetUsageComponentObject {
  public payload: Serializer<DataSource>;

  public readonly datasetDimensionsGroups$: BehaviorSubject<DatasetDimensionsGroupComponentObject> = new BehaviorSubject<DatasetDimensionsGroupComponentObject>(null);
  public readonly datasetMetricsGroups$: BehaviorSubject<DatasetMetricsGroupComponentObject> = new BehaviorSubject<DatasetMetricsGroupComponentObject>(null);
  public readonly datasetUsageCustomImports$: BehaviorSubject<CustomImportComponentObject[]> = new BehaviorSubject<CustomImportComponentObject[]>(null);
  public readonly datasetUsageCustomConfiguration$: BehaviorSubject<DatasetUsageCustomConfigurationComponentObject> = new BehaviorSubject<DatasetUsageCustomConfigurationComponentObject>(null);

  public readonly dimensionsLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public readonly metricsLoaded$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(payload: Serializer<DataSource>, customImports: CustomImportComponentObject[] = null) {
    this.update(payload);

    this.datasetDimensionsGroups$.next(new DatasetDimensionsGroupComponentObject(this.payload));
    this.datasetMetricsGroups$.next(new DatasetMetricsGroupComponentObject(this.payload));

    if (payload.relationships.data_set_usage_custom_configuration.data) {
      this.datasetUsageCustomConfiguration$.next(new DatasetUsageCustomConfigurationComponentObject(payload.relationships.data_set_usage_custom_configuration.data));
    }

    if (customImports) {
      this.datasetUsageCustomImports$.next(customImports.filter((item: CustomImportComponentObject): boolean => item.payload.relationships.data_set_usage.data.id === this.payload.id));
    }
  }

  public update(payload: Serializer<DataSource>): void {
    this.payload = payload;
  }

  public initDimensions(datasetDimensions: DimensionComponentObjects, generalDimensions: DimensionComponentObjects = []): void {
    this.datasetDimensionsGroups$.value.init(datasetDimensions, [], []);

    if (this.datasetUsageCustomConfiguration$.value) {
      this.datasetUsageCustomConfiguration$.value.initDimensions(generalDimensions, datasetDimensions);
    }
  }

  public initMetrics(datasetMetrics: MetricComponentObjects): void {
    this.datasetMetricsGroups$.value.init(datasetMetrics);

    if (this.datasetUsageCustomConfiguration$.value) {
      this.datasetUsageCustomConfiguration$.value.initMetrics(datasetMetrics);
    }
  }

}
